<div class="question-card">

    <!-- Question Section -->
    <div class="question-section">
      <div class="section-label">
        <span class="label-dot"></span>
        Question
      </div>
      <div class="question-content" *ngIf="questionObj.questionContent" [innerHTML]="questionObj.questionContent"></div>
    </div>
  
    <!-- Media Section -->
    <div class="media-section" *ngIf="getQuestionMediaLength()">
      <img [src]="questionObj.questionMedia[0]" class="question-media" alt="Question media">
    </div>
  
    <!-- Options Section -->
    <div class="options-section" *ngIf="checkIfOptionsPresent()">
      <div class="section-label">
        <span class="label-dot accent2"></span>
        Select Answer(s)
      </div>
      <div class="options-grid">
        <label
          *ngFor="let option of questionObj.options; let i = index"
          class="option-card"
          [class.selected]="isOptionSelected(option.id)"
          [style.animation-delay]="(i * 60) + 'ms'"
        >
          <input
            type="checkbox"
            class="option-checkbox"
            [checked]="isOptionSelected(option.id)"
            (change)="onOptionChange(questionObj.questionId, option.id, $event.target.checked)"
          />
          <span class="option-indicator">
            <svg *ngIf="isOptionSelected(option.id)" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          </span>
          <div class="option-body">
            <img *ngIf="checkIfInOption(option,'mediaUrl')" [src]="option.mediaUrl" class="option-img" alt="">
            <span *ngIf="checkIfInOption(option,'text')" class="option-text">{{ option.text }}</span>
          </div>
        </label>
      </div>
    </div>
  
  </div>